<template>
    <div>
        <tab-bar direction="horizontal" side="top" :entries="tabBarEntries" />
        <router-view />
    </div>
</template>

<script>
import TabBar from "../../../components/tabBar/TabBar.vue";

export default {
    data() {
        return {};
    },
    computed: {
        restaurant_id() {
            return this.$route.params.restaurant_id;
        },
        tabBarEntries() {
            return [
                {
                    to: {
                        name: "ordering_table.restaurants.configuration.settings",
                        params: { restaurant_id: this.restaurant_id },
                    },
                    title: "Configuration",
                    exactUrlMatching: true,
                },
                {
                    to: {
                        name: "ordering_table.restaurants.configuration.payment",
                        params: { restaurant_id: this.restaurant_id },
                    },
                    title: "Paiement",
                    exactUrlMatching: true,
                },
                {
                    to: {
                        name: "ordering_table.restaurants.configuration.tables",
                        params: { restaurant_id: this.restaurant_id },
                    },
                    title: "Tables QR Codes",
                    exactUrlMatching: true,
                },
                {
                    to: {
                        name: "ordering_table.restaurants.configuration.kiosks",
                        params: { restaurant_id: this.restaurant_id },
                    },
                    title: "Bornes",
                    exactUrlMatching: true,
                },
                {
                    to: {
                        name: "ordering_table.restaurants.configuration.profit_center",
                        params: { restaurant_id: this.restaurant_id },
                    },
                    title: "Centre de profits",
                    exactUrlMatching: true,
                },
            ];
        },
    },
    components: {
        TabBar,
    },
    created() {
        if (this.$route.name === "ordering_table.restaurants.configuration")
            this.$router.push({ name: "ordering_table.restaurants.configuration.settings" });
    },
};
</script>
